<template>
    <div>
        <div style="width: 100%;margin-bottom: 20px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>角色管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
  
        <!-- 搜索筛选 -->
        <!-- 搜索筛选 -->
        <el-card class="box-card" style="margin-bottom: 20px;">
            <el-form :inline="true" class="user-search" :model="formInline" size="small">
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                    <el-button size="small"  type="danger" icon="el-icon-plus" @click="add">新增</el-button>
                 
                </el-form-item>
            </el-form>
        </el-card>
  
        <!--列表-->
        <div  v-if="!VisibleMenu">
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column prop="roleId" label="id" width="100" align="center">
          </el-table-column>
          <el-table-column prop="roleName" label="角色名称" width="100" align="center">
          </el-table-column>
          <!-- <el-table-column prop="functions" label="操作权限" width="100" align="center">
          </el-table-column>
          <el-table-column prop="menus" label="菜单权限" width="100" align="center">
          </el-table-column> -->
          <!-- <el-table-column prop="status" label="是否可用" width="100" align="center">
        </el-table-column> -->
          <el-table-column align="center" label="操作" min-width="300">
              <template slot-scope="scope">
                  <el-button size="mini"   type="text"
                      @click="handleedit(scope.row)">编辑</el-button>
                      <el-button size="mini"
                      type="text"
                      @click="handleSelectResource1(scope.row)">操作权限
            </el-button>
                  <el-button size="mini"   type="text"
                  @click="handledelete(scope.row)">删除</el-button>
                  <el-button size="mini"   type="text"
                  @click="handleVisibleMenu(scope.row)">分配菜单</el-button>
             
              </template>
          </el-table-column>
        </el-table>
     
        </div> 
        <!-- 弹框 设代理和设置会员-->
       <el-dialog
      :close-on-click-modal="false"
        title="设置"
        :visible.sync="dialogVisible"
        width="30%"
        >
        <el-form>
           
            
            <!-- <el-form-item label="标签名字" >
               <el-input v-model="editForm.functions"></el-input>
                
            </el-form-item>
            <el-form-item label="标签名字" >
              <el-input v-model="editForm.menus"></el-input>
               
           </el-form-item> -->
           <el-form-item label="角色名称" >
              <el-input v-model="editForm.roleName"></el-input>
               
           </el-form-item>
           <el-form-item label="角色状态" >
              <el-input v-model="editForm.status"></el-input>
               
           </el-form-item>
           
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addEdit" >设置</el-button>
         
        </span>
      </el-dialog>
  
  
       <!-- 编辑操作权限 -->
       
      <el-dialog
      :close-on-click-modal="false" title="操作权限" :visible.sync="Visible" width="40%" @click="closeDialog" center>
  
        <el-form class="user-search" label-width="100px" size="small">
        
          <el-form-item label="角色：">
            <el-input size="small" placeholder="请输入新增类名" v-model="editChose.roleName"></el-input>
          </el-form-item>
         
          
           <el-form-item label="选择操作:">
            <el-checkbox-group v-model="ids" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="(item,index) in listData1" :label="item.id" :key="index">{{item.remark}}</el-checkbox>
            </el-checkbox-group>
           </el-form-item>
        </el-form>
  
  
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title"
            @click="addCategory(editChose.roleId)">保存</el-button>
        </div>
      </el-dialog>
     
      <!-- 分配操作列表 -->
   
    
      <!--<el-dialog
      :close-on-click-modal="false" title="操作列表权限" :visible.sync="VisibleMenu" width="40%" @click="closeDialogMenu" center>
        

    </el-dialog> -->
    </div>
  </template>
  
  <script>
    
  
    import {  roleList ,addEditRole , delRole, authFunctionList , configureRoleAuthFunction ,authMenuList  } from '../../api/pemission.js'
  
  
   
    // 导出模块
    export default {
     
        // 模块数据
        data() {
            //数据  
            return {       
                loading: true,
                Visible: false,
                editChose:{},
                ids:[],
                menuIds:[],
                listData1:[],
                listData: [],          
                dialogVisible: false,
                tagId:'',
                name:'',
                VisibleMenu:false,
                // formInline: {
                //     start: 0,
                //     length: 5,
                   
                // },
                defaultProps: {
                    children: 'children',
                    label: 'title'
                    },
                 // 分页参数
                //  pageparm: {
                //       currentPage: 1,
                //       pageSize: 5,
                //       total: 10,
                //       start: 0,
                //       length: 5
                //   },
                  editForm:{  
                      functions: "",
                      menus: "",
                      roleId: 0,
                      roleName: "",
                      status: 0,
                     
                  },
                  menuTreeList:[]
            }
        },
  
  
        watch: {},
  
        methods: {
            handleCheckedCitiesChange(val){
          console.log(val)
        },
             // 配置修改操作权限
             addCategory(roleId){
                if(this.ids.length){
                  let authFunctionIds = this.ids.join(',')
                configureRoleAuthFunction({authFunctionIds,roleId}).then(res=>{
                    if (res.code == '200') {
                  console.log(res)
                    }
                })
                }else{
                  this.$message.error('请选择操作')
                }
              
              },
              checkTree(val){
                  console.log(val)
              },
           
          closeDialog(){
                this.Visible = false
              },
          handleSelectResource1(row){
            this.$router.push({path:'/system/functionRole',query: {role: JSON.stringify(row)}})
        //   this.Visible = true
        //   this.editChose = row
        },
             // 查询
            //  search() {
            //     this.formInline.start = 0
			// 	this.pageparm.currentPage = 1
            //     this.getdata(this.formInline)
            // },
          
            showPop(){
                this.visible = true
                console.log(111)
            },
            
             getdata1() {
              authFunctionList({start:0,length:10000}).then(res=>{
                    if (res.code == '200') {
                        this.listData1 = res.data.content
                        console.log(this.listData)
                    
                        this.pageparm.total = res.data.totalElements
                    }
                })
            },
           
          getdat2() {
    
              authMenuList({start:0,length:10000}).then(res=>{
                  if (res.code == '200') {
                      this.menuTreeList = res.data.content
                  
                  }
              })
          },
            // 获得用户数据
            getdata() {
              let param = this.formInline
              roleList(param).then(res=>{
                this.saveParams(this.$route.path,this.formInline)
                    if (res.code == '200') {
                        this.listData = res.data.content
                        console.log(this.listData)
                        this.loading = false
                        this.pageparm.total = res.data.totalElements
                    }
                })
            },
            handleVisibleMenu(row){
                this.$router.push({path:'/system/menuTorole',query: {role: JSON.stringify(row)}})
                // this.VisibleMenu = true
                // this.setCheckedNodes()
                // this.editChose = row
            },
            setCheckedNodes() {
                console.log(this.$refs.tree)
                this.$refs.tree.setCheckedNodes(this.menuTreeList);
            },
            closeDialogMenu(){
                this.VisibleMenu = false
               
            },
            handleedit(row){
                this.dialogVisible = true
                this.editForm = Object.assign({}, row)
                // this.editForm = row
            },
            add(){
              this.dialogVisible = true
              this.editForm = {}
            },
            addEdit(){
                let param = this.editForm
                addEditRole(param).then(res=>{
                    if(res.code==200){
                      this.$message({
                          type: "success",
                          message: '新增成功'
                      })      
                      this.editForm={  
                      functions: "",
                      menus: "",
                      roleId: "",
                      roleName: "",
                      status:""
                  }
                  this.getdata()
                  this.dialogVisible=false
                    }
                })
      
            },
            handledelete(row){
                let msg = '确定删除该菜单吗？'
              this.$confirm(msg, '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                      delRole(row).then(res=>{
                          if(res.code==200){
                              this.$message({
                          type: "success",
                          message: '删除成功'
                      })  
                              this.getdata()
                          }   
                       })
                  })
            },
            //   // 分页插件事件
            //   callFather(parm) {
            //     this.pageparm.currentPage  = parm.currentPage
            //     this.pageparm.pageSize =  parm.pageSize 
            //     this.pageparm.start  = parm.currentPage - 1
            //     this.pageparm.length =  parm.pageSize 
            //     this.formInline.start = parm.currentPage - 1
            //     this.formInline.length = parm.pageSize
            //     this.getdata(this.formInline)
            // },
           
        },
        // 创建前状态(里面是操作)
        beforeCreate() { },
        // 创建完毕状态(里面是操作)
        created() {
            this.getParams(this.$route.path)
            this.getdata() 
            this.getdata1() 
            this.getdat2()       
        },
        // 挂载前状态(里面是操作)
        beforeMount() { },
        // 挂载结束状态(里面是操作)
        mounted() { },
        // 更新前状态(里面是操作)
        beforeUpdate() { },
        // 更新完成状态(里面是操作)
        updated() { },
        // 销毁前状态(里面是操作)
        beforeDestroy() { },
        // 销毁完成状态(里面是操作)
        destroyed() { }
    };
  </script>
  
  <style scoped>
    .el-form-item {
        width: 40%;
        box-sizing: border-box;
    }
  
    .just-start {
        display: flex;
        justify-content: flex-start;
    }
  
    .marginT20 {
        margin-top: 20px;
    }
  </style>